<i18n>
{
"en": {
  "LOADING": "Loading...",
  "SCHOOLCONFIGURATION": "School Configuration",
  "UPLOADIMAGE": "Upload Image",
  "SAVEIMAGE": "Save Image",
  "TYPESOFSCHOOL": "Types of School",
  "PUBLIC": "Public",
  "PRIVATE": "Private",
  "GENDERDIVERSITY": "Gender Diversity",
  "MALE": "Male",
  "FEMALE": "Female",
  "MIXED": "Mixed",
  "NAME": "Name",
  "NAME(ARABIC)": "Name (Arabic)",
  "COUNTRY": "Country",
  "TIMEZONE": "Time Zone",
  "PLEASESELECTYOURZONE": "please select your zone",
  "PLEASESELECTYOURTIMEZONE": "please select your time zone",
  "DATEFORMAT": "Date Format",
  "DAYMONTHYEAR": "Day/Month/Year",
  "MONTHDAYYEAR": "Month/Day/Year",
  "SELECTDATEFORMAT": "Select Date Format",
  "ADDRESS": "Address",
  "SEARCHADDRESS": "Search Address",
  "COORDINATES": "Coordinates",
  "LATITUDE": "Latitude",
  "LONGITUDE": "Longitude",
  "CONFIRM": "Confirm",
  "BUILDINGNUMBER": "Building Number",
  "STREETADDRESS": "Street Address",
  "AREA": "Area",
  "ZONE": "Zone",
  "SECTOR": "Sector",
  "CITY": "City",
  "STATE": "State",
  "ZIPCODE": "Zip Code",
  "CONTACTS": "Contacts",
  "SEARCHUSERSNAME": "Search user's name",
  "BUSCOMPANYEMAIL": "Bus Company Email",
  "BUSCOMPANYPHONENUMBER": "Bus Company Phone Number",
  "LOCALPOLICEEMAIL": "Local Police Email",
  "LOCALPOLICEPHONENUMBER": "Local Police Phone Number",
  "SCHOOLEMAIL": "School Email",
  "SCHOOLPHONENUMBER": "School Phone Number",
  "GRADES": "Grades",
  "GRADE": "Grade",
  "AGE": "Age",
  "ADDGRADE": "Add Grade",
  "ADDNEWCLASS": "Add New Class",
  "AVERAGEAGE": "Average Age",
  "EDITGRADE": "Edit Grade",
  "TIMINGS": "Timings",
  "GATEOPENTIME": "Gate Open Time",
  "CLASSSTARTTIME": "Class Start Time",
  "LATEARRIVALTIME": "Late Arrival Time",
  "SELECTMINUTES": "Select Minutes",
  "MIN": "min",
  "EARLYDEPARTURETIME": "Early Departure Time",
  "CLASSENDTIME": "Class End Time",
  "GATECLOSETIME": "Gate Close Time",
  "ACADEMICTERMS": "Academic Terms",
  "ADDNEXTACADEMICYEAR": "Add Next Academic Year",
  "TERMNAME": "Term Name",
  "STARTDATE": "Start Date",
  "ENDDATE": "End Date",
  "ADDNEWTERM": "Add new term",
  "YEAR": "Year",
  "STARTINGDATE": "Starting Date",
  "ENDINGDATE": "Ending Date",
  "SHOWNOTIFICATIONS": "Show Notifications",
  "ENABLE": "Enable",
  "DISABLE": "Disable",
  "NOTIFICATIONS": "Notifications",
  "ACTIVITIES": "Activities",
  "ACTIVITYNAME": "Activity Name",
  "ADDACTIVITY": "Add Activity",
  "EDITACTIVITY": "Edit Activity",
  "SUNDAY": "Sunday",
  "MONDAY": "Monday",
  "TUESDAY": "Tuesday",
  "WEDNESDAY": "Wednesday",
  "THURSDAY": "Thursday",
  "FRIDAY": "Friday",
  "SATURDAY": "Saturday",
  "PICKADATE": "Pick a date",
  "DAYSINSERVICE": "Days in Service",
  "STARTTIME": "Start time",
  "ENDTIME": "End time",
  "DELETEACTIVITY": "Delete Activity",
  "SELECTDAYS": "Select Days",
  "DELETEGRADE": "Delete Grade",
  "GRADEASSIGNEDTOSTUDENT": "This grade has been assigned to student(s)",
  "ACTIVITYASSIGNEDTOSTUDENT": "This activity has been assigned to student(s)",
  "ERROR": "Error",
  "CLOSE": "Close",
  "ISREQUIRED": "is required.",
  "ISNOTAVALIDARABICFORMAT": "is not a valid arabic format.",
  "ALREADYEXISTED": "already existed.",  
  "MUSTBEATLEASTCHARACTERSINLENGTH": "must be at least {len} characters in length.",
  "CANNOTEXCEEDCHARACTERSINLENGTH": "cannot exceed {len} characters in length.",  
  "INVALIDPHONENO": "is invalid phone number.",
  "MUSTCONTAINAVALIDEMAILADDRESS": "must contain a valid email address.",
  "THRESHOLD": "Threshold For",
  "EXTRAFEATURES": "Extra Features",
  "INCLUDEWIOTBOX": "WIOT Box",
  "DELAYEDSTARTTIME": "Delayed Start Time",
  "MAXIMUMDURATION": "Maximum Duration",
  "STANDINGINFRONTCHILDHOUSE": "Standing Infront of Child House",
  "DROPPEDOFINWRONGPLACE": "Dropped-of In Wrong Place",
  "METER": "Meter",
  "SELECTMETERS": "Select Meters",
  "PARENTMESSAGES": "Parent App Messages",
  "CHECKALL": "Check all",
  "MESSAGES": "Messages",
  "MSGTOPARENT": "Message to Parents",
  "REPORTABSENCE": "Report Absence",
  "EMAILTEACHER": "Email Teacher",
  "CALLDRIVER": "Call Driver",
  "CALLNAANY": "Call Nanny",
  "MSGTONAANY": "Message to Nanny",
  "CALLSCHOOL": "Call School",
  "EMAILSCHOOL": "Email School"  
},
"ar": {
  "LOADING": "جار التحميل...",
  "SCHOOLCONFIGURATION": "تكوين المدرسة",
  "UPLOADIMAGE": "تحميل الصور",
  "SAVEIMAGE": "احفظ الصورة",
  "TYPESOFSCHOOL": "نوع المدارس",
  "PUBLIC": "عامة",
  "PRIVATE": "خاصة",
  "GENDERDIVERSITY": "التنوع بين الجنسين",
  "MALE": " ذكر",
  "FEMALE": "أنثى",
  "MIXED": "مختلط",
  "NAME": "الإسم",
  "NAME(ARABIC)": "الإسم (عربي)",
  "COUNTRY": "البلد",
  "TIMEZONE": "المناطق الزمنية",
  "PLEASESELECTYOURZONE": "الرجاء تحديد منطقتك",
  "PLEASESELECTYOURTIMEZONE":"يرجى تحديد المنطقة الزمنية",
  "DATEFORMAT": "صيغة التاريخ",
  "DAYMONTHYEAR": " يوم/شهر/سنة",
  "MONTHDAYYEAR": " شهر/ يوم /سنة",
  "SELECTDATEFORMAT": "حدد تنسيق التاريخ",
  "ADDRESS": "العنوان",
  "SEARCHADDRESS": "بحث العنوان",
  "COORDINATES": "إحداثيات",
  "LATITUDE": "الخط العامودي",
  "LONGITUDE": "الخط الطولي",
  "CONFIRM": "تأكد",
  "BUILDINGNUMBER": "رقم المبنى",
  "STREETADDRESS": "عنوان الشارع",
  "STREETNUMBER": "رقم الشارع",
  "AREA": "النطقة",
  "ZONE": "الحوض",
  "SECTOR": "القسم",
  "CITY": "المدينة",
  "STATE": "الامارة",
  "ZIPCODE": "الرمز البريدي",
  "CONTACTS": "جهات الاتصال",
  "SEARCHUSERSNAME": "ابحث عن إسم المستخدم",
  "BUSCOMPANYEMAIL": "البريد الإلكتروني لشركة الحافلات",
  "BUSCOMPANYPHONENUMBER": "رقم هاتف شركة الحافلات",
  "LOCALPOLICEEMAIL": "البريد الإلكتروني للشرطة المحلية",
  "LOCALPOLICEPHONENUMBER": "رقم هاتف الشرطة المحلية",
  "SCHOOLEMAIL": "البريد الإلكتروني للمدرسة",
  "SCHOOLPHONENUMBER": "رقم هاتف المدرسة",  
  "GRADES": "درجات",
  "GRADE": "درجة",
  "AGE": "السن",
  "ADDGRADE": "إضافة الصف",
  "ADDNEWCLASS": "إضافة صف جديد",
  "AVERAGEAGE": "متوسط ​​العمر",
  "EDITGRADE": "تحرير الصف",
  "TIMINGS": "توقيت",
  "GATEOPENTIME": "وقت فتح البوابة",
  "CLASSSTARTTIME": "وقت بداية الصف",
  "LATEARRIVALTIME": "وقت الوصول المتأخر",
  "SELECTMINUTES": "حدد الوقت",
  "MIN": "الدقائق",
  "EARLYDEPARTURETIME": "وقت المغادرة المبكر",
  "CLASSENDTIME": "وقت نهاية الصف",
  "GATECLOSETIME": "وقت إغلاق البوابة",
  "ACADEMICTERMS": "السنة الأكاديمية",
  "ADDNEXTACADEMICYEAR": "إضافة السنة الدراسية التالية",
  "TERMNAME": "إسم الفترة الدراسية",
  "STARTDATE": "تاريخ البدء",
  "ENDDATE": "تاريخ الانتهاء",
  "ADDNEWTERM": "إضافة موسم جديد",
  "YEAR": "عام",
  "STARTINGDATE": "تاريخ البدء",
  "ENDINGDATE": "تاريخ الانتهاء",
  "SHOWNOTIFICATIONS": "إظهار الإشعارات",
  "ENABLE": "مكن",
  "DISABLE": "تعطيل",
  "NOTIFICATIONS": "إشعارات",
  "ACTIVITIES": "أنشطة",
  "ACTIVITYNAME": "اسم النشاط",
  "ADDACTIVITY": "إضافة نشاط",
  "EDITACTIVITY": "تحرير نشاط",
  "SUNDAY": "الأحد",
  "MONDAY": "الإثنين",
  "TUESDAY": "الثلاثاء",
  "WEDNESDAY": "الأربعاء",
  "THURSDAY": "الخميس",
  "FRIDAY": "الجمعة",
  "SATURDAY": " السبت",
  "PICKADATE": "اختر تاريخا",
  "DAYSINSERVICE": "أيام الخدمة",
  "STARTTIME": "بداية الخدمة",
  "ENDTIME": "نهاية الخدمة",
  "DELETEACTIVITY": "حذف نشاط",
  "SELECTDAYS": "حدد الأيام",
  "DELETEGRADE": "حذف الدرجة",
  "GRADEASSIGNEDTOSTUDENT": " تم تعيين هذا الصف للطالب",
  "ACTIVITYASSIGNEDTOSTUDENT": "تم تعيين هذا النشاط للطالب",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "ISNOTAVALIDARABICFORMAT": ".ليست صيغة عربية صحيحة"  ,   
  "ISREQUIRED": ".مطلوب",
  "MUSTBEATLEASTCHARACTERSINLENGTH": ".يجب أن تكون على الأقل {len} حرفا",
  "CANNOTEXCEEDCHARACTERSINLENGTH": ".لا يمكن أن يتجاوز {len} حرفا",  
  "INVALIDPHONENO": ".رقم هاتف غير صالح",
  "MUSTCONTAINAVALIDEMAILADDRESS": ".يجب أن يحتوي على عنوان بريد إلكتروني صالح",
  "EXTRAFEATURES": "ميزات اضافية",
  "INCLUDEWIOTBOX": "WIOT Box",
  "PARENTMESSAGES": "رسائل تطبيق اولياء الامور",
  "CHECKALL": "تحقق من الكل",
  "MESSAGES": "الرسائل",
  "MSGTOPARENT": "رسالة إلى أولياء الأمور",
  "REPORTABSENCE": "تقرير الغياب",
  "EMAILTEACHER": "أرسل رسالة إلى المعلم",
  "CALLDRIVER": "اتصل بالسائق",
  "CALLNAANY": "اتصل بالمشرفة",
  "MSGTONAANY": "رسالة إلى المشرفة",
  "CALLSCHOOL": "اتصل بالمدرسة",
  "EMAILSCHOOL": "البريد الإلكتروني للمدرسة"
 }
}
</i18n>
<template>
  <div class="form"  v-loading="loading" :element-loading-text="$t('LOADING')">
    <el-card class="card-border" ref="card" :body-style="{ padding: '0px' }">
    <wi-save slot="header" :form="['mainForm', 'contactForm']" :title="$t('SCHOOLCONFIGURATION')" :data="{school: this.school, address: this.address, grades: this.grades, timing: this.timing, terms: this.academicTerms}" :redirect="false" :auth="true"></wi-save>
    <el-row>
      <el-col :span="10">
        <el-tabs type="border-card"  class="tabs"  v-bind:style="{ height: cardHeight + 'px' }">
          <el-form ref="mainForm" :model="school" label-width="120px" label-position="top">
            <el-row :gutter="20" style="margin-bottom: 20px">
              <el-col :span="12">
                <wi-upload :person="school" :logo="true"></wi-upload>  
 
              </el-col>
              <el-col :span="12">
              <el-row>
                <el-form-item :label="$t('TYPESOFSCHOOL')" prop="Type" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change'}">
                  <el-radio-group size="small" v-model="school.Type">
                    <el-radio-button label="0">{{$t('PUBLIC')}}</el-radio-button>
                    <el-radio-button label="1">{{$t('PRIVATE')}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                </el-row>
                    <el-row>
                <el-form-item :label="$t('GENDERDIVERSITY')" prop="Gender" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change'}">
                  <el-radio-group size="small" v-model="school.Gender">
                    <el-radio-button label="Male">{{$t('MALE')}}</el-radio-button>
                    <el-radio-button label="Female">{{$t('FEMALE')}}</el-radio-button>
                    <el-radio-button label="Mixed">{{$t('MIXED')}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
                    </el-row>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('NAME')"  prop="Name_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'}]">
                  <el-input v-model="school.Name_EN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('NAME(ARABIC)')" prop="Name_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="school.Name_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">

              <el-col :span="12">
                <el-form-item :label="$t('COUNTRY')" prop="Country" :rules="{required:true, message:$t('ISREQUIRED'), trigger:'blur'}">
                  <el-select v-model="school.Country" @change="changeAutoComplete()" :placeholder="$t('PLEASESELECTYOURZONE')" filterable>
                    <el-option :key="key" v-for="(stop, key) in $countries" :label="stop" :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('DATEFORMAT')">
                  <el-select   v-model="school.DateFormat" :placeholder="$t('SELECTDATEFORMAT')">
                    <el-option :label="$t('DAYMONTHYEAR')" value="dd/MM/yyyy"></el-option>
                     <el-option :label="$t('MONTHDAYYEAR')" value="MM/dd/yyyy"></el-option>
                  </el-select>
                </el-form-item>

              </el-col>
            </el-row>

            <!--el-row :gutter="20">

              <el-col :span="12">
                <el-form-item :label="$t('TIMEZONE')">
                  <el-select v-model="school.TimeZone" :placeholder="$t('PLEASESELECTYOURTIMEZONE')" filterable>
                    <el-option value=""></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row-->
          </el-form>
        </el-tabs>
      </el-col>
      <el-col :span="14">
        <el-tabs class="formTab" type="border-card"   v-bind:style="{ height: cardHeight + 'px' }">
          <el-tab-pane :label="$t('ADDRESS')">

            <VuePerfectScrollbar class="scrollbar"  ref="addressBar"  v-bind:style="{ height: cardHeight - 42 + 'px' }">
            <el-form  ref="form" :model="address" label-width="120px" label-position="top">
              <el-row class="googleMap"> 
                      <div   id="school-gmap"  style="width: 100%; height: 200px"></div>
               <input :disabled="!school.Country" type="text" :placeholder="$t('SEARCHADDRESS')" v-model="school.Address" id="location" class="el-input__inner" style="padding: 25px 10px;" autocomplete="off" />
              </el-row>
                <div>
                  <el-row>
                    <el-form-item :label="$t('COORDINATES')">

                      <el-col :span="8">
                        <el-input :disabled="!school.Country" v-model="school.Lat" @change="enableConfirm = true">
                          <template slot="prepend">{{$t('LATITUDE')}}</template>
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="8">
                        <el-input :disabled="!school.Country" v-model="school.Lng" @change="enableConfirm = true">
                          <template slot="prepend">{{$t('LONGITUDE')}}</template>
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="6">
                        <el-button :disabled="!enableConfirm" @click="changeMarkerPosition(school.Lat, school.Lng)">{{$t('CONFIRM')}}</el-button>
                      </el-col>
                    </el-form-item>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('BUILDINGNUMBER')">
                        <el-input :disabled="!school.Country" v-model="address.HouseNumber"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('STREETADDRESS')">
                        <el-input :disabled="!school.Country" v-model="address.Address"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('AREA')">
                        <el-input :disabled="!school.Country" v-model="address.Area"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('ZONE')">
                        <el-input :disabled="!school.Country" v-model="address.Zone"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('SECTOR')">
                        <el-input :disabled="!school.Country" v-model="address.Sector"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('CITY')">
                        <el-input :disabled="!school.Country" v-model="address.City"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item :label="$t('STATE')">
                        <el-input :disabled="!school.Country" v-model="address.State"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('ZIPCODE')">
                        <el-input :disabled="!school.Country" v-model="address.ZipCode"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-form>
            </VuePerfectScrollbar>


          </el-tab-pane>
          <el-tab-pane :label="$t('CONTACTS')">

        <div class="media">
              <div class="media-left">
                  <img class="media-object img-circle" style="width: 80px" :src="getAsset(adminImage, 'user')" />
              </div>
              <div class="media-body">
                  <h5 class="media-heading">
                    <el-autocomplete
                            v-model="admin"
                            :fetch-suggestions="querySearch"
                            :placeholder="$t('SEARCHUSERSNAME')"
                            @select="changeUser"
                            icon="search"
                    ></el-autocomplete> 
                  </h5>
              </div>
            </div>    
            <el-form ref="contactForm" :model="school" label-width="120px" label-position="top" style="margin-top:15px; padding:15px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('SCHOOLEMAIL')" prop="AdminEmail" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{min:6, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 6}), trigger:'blur'},{type:'email', message:$t('MUSTCONTAINAVALIDEMAILADDRESS'), trigger:'blur'},{max:50, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 50}), trigger:'blur'}]">
                  <el-input v-model="school.AdminEmail"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('SCHOOLPHONENUMBER')" prop="AdminPhone" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }]">
                  <el-input v-model="school.AdminPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('BUSCOMPANYEMAIL')" prop="BusCompanyEmail" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{min:6, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 6}), trigger:'blur'},{type:'email', message:$t('MUSTCONTAINAVALIDEMAILADDRESS'), trigger:'blur'},{max:50, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 50}), trigger:'blur'}]">
                  <el-input v-model="school.BusCompanyEmail"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('BUSCOMPANYPHONENUMBER')" prop="BusCompanyContact" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }]">
                  <el-input v-model="school.BusCompanyContact"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('LOCALPOLICEEMAIL')" prop="PoliceEmail" :rules="[{min:6, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 6}), trigger:'blur'},{type:'email', message:$t('MUSTCONTAINAVALIDEMAILADDRESS'), trigger:'blur'},{max:50, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 50}), trigger:'blur'}]">
                  <el-input v-model="school.PoliceEmail"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('LOCALPOLICEPHONENUMBER')" prop="PoliceContact" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }]">
                  <el-input v-model="school.PoliceContact"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
              </el-form>
          </el-tab-pane>

          <el-tab-pane :label="$t('GRADES')">
          <el-row style="padding:15px" :gutter="20">
            <el-form ref="gradeForm" :model="grade" label-width="120px" label-position="top">
            <el-col :span="6">
              <el-form-item prop="Grade" :rules="[{min:1, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 1}), trigger:'blur'},{max:10, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 8}), trigger:'blur'}]" style="margin-bottom: 0px;">
                <el-input :placeholder="$t('GRADE')" v-model="grade.Grade"></el-input>
              </el-form-item>
            </el-col> 
            <el-col :span="6">
              <el-input :placeholder="$t('AGE')" v-model="grade.Age"></el-input>
            </el-col> 
            <el-col :span="6">
              <el-button :disabled="gradeValidation()" @click="newGrade">
                <i class="fa fa-plus"></i> {{gradeIndex==null ? $t('ADDGRADE') : $t('SAVE')}}
              </el-button>
            </el-col>
            </el-form> 
          </el-row>   
          <el-table
          :data="grades"
          :height="cardHeight-118"
          style="width: 100%;">
          <el-table-column type="expand">
            <template slot-scope="props">
      
            <el-row :gutter="20">

            <el-col :span="6"  style="margin-bottom:10px"  :key="index" v-for="(value, index) in props.row.Classes">
            
                <el-input v-model="props.row.Classes[index]">
                <el-button slot="prepend" icon="close" @click="props.row.Classes.splice(index, 1)"></el-button>
                </el-input>
            </el-col>
              <el-col :span="4">
              <el-button size="small" :disabled="props.row.Classes[props.row.Classes.length - 1]==''" @click="props.row.Classes.push('')"><i class="fa fa-plus"></i> {{$t('ADDNEWCLASS')}}</el-button>
            </el-col>
            </el-row>
        
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('GRADE')"
            prop="Name">
          </el-table-column>
              <el-table-column
            :label="$t('AVERAGEAGE')"
            prop="Age"
            align="center">
          </el-table-column>

            <el-table-column align="right">
            <template slot-scope="props">
            <el-tooltip :content="$t('EDITGRADE')" placement="top">
              <el-button v-if="props.$index!=gradeIndex" type="text" @click="editGrade(props.$index)"><i class="fa fa-pencil"></i></el-button>
            </el-tooltip>
            <el-tooltip :content="$t('DELETEGRADE')" placement="top">
              <el-button type="text" @click="deleteGrade(props.$index,props.row.GradeID, props.row.Name)"><i class="fa fa-times"></i></el-button>
            </el-tooltip>
            </template>
          </el-table-column>  
        </el-table>
        </el-tab-pane>
          <el-tab-pane :label="$t('TIMINGS')">
          <el-form ref="form" :model="timing" label-width="120px" label-position="top" style="padding:15px">
           <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('GATEOPENTIME')">
                  <el-time-select
                    :placeholder="$t('GATEOPENTIME')" v-model="timing.GateOpen"  :picker-options="{start: '00:15', step: '00:15', end: '24:00'}">
                  </el-time-select>
                </el-form-item>  
              </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('CLASSSTARTTIME')">
                    <el-time-select
                      :placeholder="$t('CLASSSTARTTIME')"   v-model="timing.ClassStart" :picker-options="{start: '00:15', step: '00:15', end: '24:00', minTime: timing.OpenTime}">

                    </el-time-select>
                  </el-form-item>  
              </el-col>
              <el-col :span="8">
                  <el-form-item :label="$t('LATEARRIVALTIME')">
                    <el-select   v-model="timing.LateArrival" clearable filterable  :placeholder="$t('SELECTMINUTES')">
                        <el-option :key="index" v-for="(num, index) in minutes"  :label="num + ' ' + $t('MIN')"  :value="num"></el-option>
                    </el-select>
      
                  </el-form-item>  
              </el-col>
              </el-row>

              <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('EARLYDEPARTURETIME')">
                  <el-time-select
                    :placeholder="$t('EARLYDEPARTURETIME')" v-model="timing.EarlyDeparture"  :picker-options="{start: '00:15', step: '00:15', end: '24:00', minTime: timing.ArrivalTime}">
                  </el-time-select>
                </el-form-item>  
              </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('CLASSENDTIME')">
                    <el-time-select
                      :placeholder="$t('CLASSENDTIME')"  v-model="timing.ClassEnd" :picker-options="{start: '00:15', step: '00:15', end: '24:00', minTime: timing.DepartureTime}">

                    </el-time-select>
                  </el-form-item>  
              </el-col>
              <el-col :span="8">
                  <el-form-item :label="$t('GATECLOSETIME')">
                    <el-time-select
                      :placeholder="$t('GATECLOSETIME')"  v-model="timing.GateClose" :picker-options="{start: '00:15', step: '00:15', end: '24:00', minTime: timing.EndTime}">
                    </el-time-select>
                  </el-form-item>  
              </el-col>
              </el-row>
              </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('ACADEMICTERMS')">
            <el-row style="padding:15px" :gutter="20">
              <el-col :span="6">
                <el-button  @click="newTerm"><i class="fa fa-plus"></i> {{$t('ADDNEXTACADEMICYEAR')}}</el-button>
              </el-col> 
            </el-row>      
            <el-table
            :data="academicTerms"
            :height="cardHeight-118"
            @expand="expandRow"
            style="width: 100%;">
            <el-table-column type="expand" style="padding:10px">
              <template slot-scope="props">

              <el-row :gutter="20" v-if="props.row.terms.length!=0" style="font-weight:bold">
              <el-col :span="6">
              {{$t('TERMNAME')}}
              </el-col>
              <el-col :span="8">
              {{$t('STARTDATE')}}
              </el-col>
              <el-col :span="8">
              {{$t('ENDDATE')}}
              </el-col>
              <el-col :span="2">
              </el-col>
              </el-row>

              <el-row :gutter="20" :key="key" v-for="(term,key) in props.row.terms" style="padding:15px 0">
              <el-col :span="6">
                  <el-input :disabled="term.IsDeleted==1" v-model="term.Name"></el-input>
              </el-col>
              <el-col :span="8">
                  <el-date-picker :disabled="term.IsDeleted==1" :format="date_format" type="date" :picker-options="{disabledDate: activeDates}" @change="restricNextDate(term.StartDate, key)" :placeholder="$t('STARTDATE')" v-model="term.StartDate" :default-value="new Date(props.row.year.split('/')[0]+ '-01-01')"></el-date-picker>
              </el-col>
              <el-col :span="8">
                  <el-date-picker :disabled="term.IsDeleted==1" :format="date_format" type="date" :placeholder="$t('ENDDATE')" v-model="term.EndDate" :default-value="new Date(props.row.year.split('/')[0]+ '-01-01')"></el-date-picker>
              </el-col>
              <el-col :span="2">
                    <i @click="term.IsDeleted=(term.IsDeleted==0 ? 1 : 0)" class="fa" v-bind:class="[term.IsDeleted==0 ? 'fa-times' : ' fa-undo']" style="font-size:25px; margin-top:5px"></i>
              </el-col>
              </el-row>
              <el-row>
              <el-button  @click="props.row.terms.push({Name:'',YearID: props.row.YearID, StartDate:'', EndDate:'', IsDeleted:0})"> <i class="fa fa-plus"></i> {{$t('ADDNEWTERM')}}</el-button>
              </el-row>
              </template>

            </el-table-column>
            <el-table-column
              :label="$t('YEAR')"
              prop="year">
            </el-table-column>

            <el-table-column
              :label="$t('STARTINGDATE')"
              >
              <template  slot-scope="props">
                {{props.row.terms.length==0 ? '-' : dateFormat(props.row.terms[0].StartDate)}}
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('ENDINGDATE')"
              >
              <template  slot-scope="props">
                {{props.row.terms.length==0 ? '-' : dateFormat(props.row.terms[props.row.terms.length-1].EndDate)}}
              </template>
            </el-table-column>
        
          </el-table>         
          </el-tab-pane>

          <el-tab-pane :label="$t('ACTIVITIES')">
            <el-form  label-width="120px" label-position="top" style="padding:15px">
              <el-row :gutter="20">
                <el-col :span="8">
                <el-input :placeholder="$t('ACTIVITYNAME')" v-model="Activity.Name"></el-input>
                </el-col> 
                <el-col :span="8">
                  <el-time-select
                    :placeholder="$t('STARTTIME')" v-model="Activity.StartTime"  :picker-options="{start: '06:00', step: '00:15', end: '16:00'}">
                  </el-time-select>
                </el-col>                    
                <el-col :span="8">
                  <el-time-select
                    :placeholder="$t('ENDTIME')"  v-model="Activity.EndTime" :disabled="Activity.StartTime==null" :picker-options="{start: Activity.StartTime, step: '00:15', end: '16:00', minTime: Activity.StartTime}">
                  </el-time-select>
                </el-col>
              </el-row>
            <el-row  :gutter="20" style="margin-top:20px">
              <el-col :span="8">
                <el-date-picker
                    v-model="Activity.Date"
                    type="daterange"
                    :placeholder="$t('PICKADATE')">
                </el-date-picker> 
              </el-col> 
              <el-col :span="8">
                <el-select v-model="Activity.Days" multiple :placeholder="$t('SELECTDAYS')">
                  <el-option
                   :key="key"
                    v-for="(item, key) in daysC"
                    :label="item"
                    :value="key">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-button :disabled="Activity.Name==null" @click="saveActivity">
                  <i class="fa fa-plus"></i> {{Activity.ID==null ? $t('ADDACTIVITY') : $t('SAVE')}}
                </el-button>
              </el-col> 
            </el-row>
          </el-form>
          <el-table
          :data="activities"
          :height="cardHeight-118"
          style="width: 100%;">

          <el-table-column
            :label="$t('ACTIVITYNAME')"
            prop="Name">
          </el-table-column>

            <el-table-column align="right">
            <template slot-scope="props">       
            <el-tooltip :content="$t('EDITACTIVITY')" placement="top">
              <el-button v-if="Activity.ID!=props.row.ID" type="text" @click="Activity=props.row"><i class="fa fa-pencil"></i></el-button>
            </el-tooltip>
            <el-tooltip :content="$t('DELETEACTIVITY')" placement="top">
              <el-button type="text" @click="deleteActivity(props.$index,props.row.ID)"><i class="fa fa-times"></i></el-button>
            </el-tooltip>
            </template>
          </el-table-column>      
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('MESSAGES')">
          <el-form  label-width="120px" label-position="top" style="padding:15px">
            <el-row>
              <el-form-item :label="$t('PARENTMESSAGES')">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('CHECKALL')}}</el-checkbox>
                <div style="margin: 15px 0"></div>
                <el-checkbox-group v-model="school.Messages" @change="handleCheckedMessageChange">
                  <el-col :span="6" :key="key" v-for="(message, key) in parentMessages">
                  <el-checkbox :disabled="key === 2" :label="key.toString()" :key="key">{{$t(message)}}</el-checkbox>
                  </el-col>
                </el-checkbox-group>
              </el-form-item>
            </el-row>            
          </el-form>
        </el-tab-pane>  
         <el-tab-pane :label="$t('EXTRAFEATURES')">
            <el-form  label-width="120px" label-position="top" style="padding:15px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="$t('SHOWNOTIFICATIONS')">
                      <el-radio-group size="small" v-model="school.Notification">
                        <el-radio-button label="0">{{$t('DISABLE')}}</el-radio-button>
                        <el-radio-button label="1">{{$t('ENABLE')}}</el-radio-button>
                      </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('INCLUDEWIOTBOX')">
                      <el-radio-group size="small" v-model="school.WiotBox">
                        <el-radio-button label="0">{{$t('DISABLE')}}</el-radio-button>
                        <el-radio-button label="1">{{$t('ENABLE')}}</el-radio-button>
                      </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>  
              <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item :label="$t('THRESHOLD') + ' ' + $t('MAXIMUMDURATION')">
                      <el-select   v-model="school.Threshold.Duration"  :placeholder="$t('SELECTMINUTES')">
                          <el-option :key="index" v-for="(num, index) in minutes"  :label="num + ' ' + $t('MIN')"  :value="num"></el-option>
                      </el-select>
                    </el-form-item>  
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('THRESHOLD') + ' ' + $t('STANDINGINFRONTCHILDHOUSE')">
                      <el-select   v-model="school.Threshold.Standing"  :placeholder="$t('SELECTMINUTES')">
                          <el-option :key="index" v-for="(num, index) in standingMinutes"  :label="num + ' ' + $t('MIN')"  :value="num"></el-option>
                      </el-select>
                    </el-form-item>  
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('THRESHOLD') + ' ' + $t('DROPPEDOFINWRONGPLACE')">
                      <el-select   v-model="school.Threshold.Dropped"  :placeholder="$t('SELECTMETERS')">
                          <el-option :key="index" v-for="(num, index) in meters"  :label="num + ' ' + $t('METER')"  :value="num"></el-option>
                      </el-select>
                    </el-form-item>  
                </el-col>
              </el-row>                             
              </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    </el-card>
    <el-dialog :title="$t('ERROR')" v-model="error" size="tiny">
      <div class="el-alert el-alert--error">
        <i class="el-alert__icon el-icon-circle-cross is-big"></i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold" v-for="(messageError, key) in message" v-html="printError(messageError, key)"></span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import axios from 'axios'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import WiUpload from '@/components/dialogs/Upload'
  import WiSave from '@/components/dialogs/Save'
  export default {
    components: {VuePerfectScrollbar, 'wi-upload': WiUpload, 'wi-save': WiSave},
    data () {
      return {
        school: {Gender: null, Type: null, DateFormat: null, Notification: false, Address: null, Threshold: {}},
        address: {},
        timing: {ClassEnd: null, ClassStart: null, EarlyDeparture: null, GateClose: null, GateOpen: null, LateArrival: undefined},
        academicTerms: [],
        grades: [],
        activities: [],
        adminImage: null,
        admin: null,
        gradeIndex: null,
        activeIndex: '',
        handleSelect: '',
        dialogVisible: false,
        dialogImageUrl: '',
        cardHeight: 0,
        center: {lat: 0, lng: 0},
        markers: [],
        minutes: [5, 10, 15, 20, 25, 30],
        standingMinutes: [2, 4, 6, 8, 10],
        meters: [25, 50, 75, 100],
        AcademicYear: null,
        grade: {Grade: null, Age: null},
        Location: null,
        country: null,
        date_format: 'dd/MM/yyyy',
        loading: false,
        sessionDialog: false,
        message: null,
        error: false,
        maps: null,
        map: null,
        marker: null,
        selectedYear: null,
        autoSource: null,
        Activity: {ID: null, Name: null, Date: [null, null], StartTime: null, EndTime: null, Days: []},
        postData: {},
        isIndeterminate: false,
        checkAll: false,
        parentMessages: ['MSGTOPARENT', 'REPORTABSENCE', 'EMAILTEACHER', 'CALLDRIVER', 'CALLNAANY', 'MSGTONAANY', 'CALLSCHOOL', 'EMAILSCHOOL'],
        enableConfirm: false
      }
    },
    mounted () {
      this.switchLanguage()
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.getConfiguration()
    },
    computed: {
      daysC () {
        let days = [this.$t('SUNDAY'), this.$t('MONDAY'), this.$t('TUESDAY'), this.$t('WEDNESDAY'), this.$t('THURSDAY'), this.$t('FRIDAY'), this.$t('SATURDAY')]
        this.days = days
        return days
      }
    },
    methods: {
      printError (message, key) {
        if (key === 'exception') return message
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      changeAutoComplete () {
        let self = this
        this.$google.then(function (Maps) {
          let autocomplete = new Maps.places.Autocomplete((document.getElementById('location')), {componentRestrictions: {country: self.school.Country}})
          Maps.event.addListener(autocomplete, 'place_changed', function () {
            self.setPlace(autocomplete.getPlace())
          })
        })
      },
      handleCheckAllChange (event) {
        this.school.Messages = event.target.checked ? Object.keys(this.parentMessages) : []
        this.isIndeterminate = false
      },
      handleCheckedMessageChange (value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.parentMessages.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.parentMessages.length
      },
      loadSchoolMap () {
        let userData = JSON.parse(localStorage.getItem('userData'))
        this.center = {lat: userData.school_location.Lat, lng: userData.school_location.Lng}
        let self = this
        this.$google.then(function (Maps) {
          let positon = new Maps.LatLng(self.center)
          self.maps = Maps
          self.map = new Maps.Map(document.getElementById('school-gmap'), {
            center: positon,
            zoom: 14
          })
          self.marker = new Maps.Marker({
            position: positon,
            icon: require('../../assets/img/map/school.png')
          })
          self.marker.setMap(self.map)
          self.marker.addListener('dragend', self.changePosition)
          let autocomplete = new Maps.places.Autocomplete((document.getElementById('location')), {componentRestrictions: {country: self.school.Country}})
          Maps.event.addListener(autocomplete, 'place_changed', function () {
            self.setPlace(autocomplete.getPlace())
          })
        })
      },
      phoneValidation (rule, value, callback) {
        let regex = /^\+?[\d-]+$/
        if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'))
        callback()
      },
      imageUploaded (res) {
        if (res.file_name !== undefined) this.school.Logo = res.file_name
      },
      getConfiguration () {
        let self = this
        this.loading = true
        this.$http.get('/configuration').then(function (response) {
          self.loading = false
          self.school = response.data.school
          self.admin = response.data.admin.FullName_EN
          self.adminImage = response.data.admin.ImagePath
          if (Object.keys(response.data.timing).length !== 0) self.timing = response.data.timing
          self.academicTerms = response.data.academic_terms
          self.grades = response.data.grades
          self.activities = response.data.activities
          for (let activity in self.activities) {
            self.activities[activity].Date = [self.activities[activity].StartDate, self.activities[activity].EndDate]
            if (self.activities[activity].Days !== null) {
              self.activities[activity].Days = (self.activities[activity].Days.split(',')).map(Number)
            } else {
              self.activities[activity].Days = []
            }
            delete self.activities[activity].StartDate
            delete self.activities[activity].EndDate
          }
          if (response.data.address !== null) self.address = response.data.address
          self.center = {lat: parseFloat(self.school.Lat), lng: parseFloat(self.school.Lng)}
          self.marker = {lat: parseFloat(self.school.Lat), lng: parseFloat(self.school.Lng), icon: require('../../assets/img/map/school.png')}
          self.loadSchoolMap()
        }).catch(function (response) {})
      },
      querySearch (queryString, cb) {
        let self = this
        if (self.admin === null) return
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findUser(queryString)
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      findUser (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/user/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=config', {cancelToken: this.autoSource.token})
      },
      changeUser (data) {
        this.school.AdminID = data.PersonID
      },
      gradeValidation () {
        if (!this.grade.Grade || !this.grade.Age) return true
        if (this.grade.Grade.length < 1 || this.grade.Grade.length > 8) return true
        return false
      },
      newTerm () {
        let year = new Date().getFullYear()
        if (this.academicTerms.length !== 0) {
          let term = this.academicTerms[this.academicTerms.length - 1]
          year = term.year.split('/')[1]
        }
        let AcademicYear = year + '/' + (parseInt(year) + 1)
        this.academicTerms.push({year: AcademicYear, YearID: null, terms: []})
      },
      newGrade () {
        if (this.gradeIndex !== null) {
          this.grades[this.gradeIndex].Name = this.grade.Grade
          this.grades[this.gradeIndex].Age = this.grade.Age
        } else {
          this.grades.push({GradeID: null, Name: this.grade.Grade, Age: this.grade.Age, Classes: []})
        }
        this.grade.Grade = this.grade.Age = this.gradeIndex = null
      },
      getSchoolPhoto (image) {
        if (image === undefined) return this.BASEURL + 'uploads/thumbnails/no-school.png'
        image = image !== null && image !== '' ? image : 'no-school.png'
        return this.BASEURL + 'uploads/thumbnails/' + image
      },
      setPlace (place) {
        this.school.Lat = place.geometry.location.lat()
        this.school.Lng = place.geometry.location.lng()
        this.school.Address = document.getElementById('location').value
        this.marker.setPosition(new this.maps.LatLng(this.school.Lat, this.school.Lng))
        this.map.panTo(this.marker.getPosition())
        this.marker.setMap(this.map)
      },
      dateChange (date) {
        return this.$moment(date).format('YYYY/MM/DD')
      },
      dateFormat (value) {
        return this.$moment(value).format(this.date_format.toUpperCase())
      },
      editGrade (index) {
        this.gradeIndex = index
        this.grade.Grade = this.grades[index].Name
        this.grade.Age = this.grades[index].Age
      },
      activeDates (time) {
        let year = this.selectedYear.split('/')
        if (time.getFullYear() === parseInt(year[0]) || time.getFullYear() === parseInt(year[1])) {
          return false
        } else return true
      },
      restricNextDate (key, val) {
        console.log(key, val)
      },
      expandRow (row, expanded) {
        if (expanded) this.selectedYear = row.year
      },
      changedAddess (val) {
        console.log('test')
      },
      changePosition (marker) {
        this.school.Lat = marker.latLng.lat()
        this.school.Lng = marker.latLng.lng()
      },
      saveActivity () {
        let postData = Object.assign({}, this.Activity)
        let self = this
        this.$http.post('/configuration/saveActivity', postData).then(function (response) {
          let data = response.data
          if (data !== '') {
            self.Activity.ID = data
            self.activities.push(self.Activity)
          }
          self.Activity = Object.assign({}, {ID: null, Name: null, Date: [null, null], StartTime: null, EndTime: null, Days: []})
        }).catch(function () {})
      },
      deleteActivity (key, ID) {
        let self = this
        let postData = {ID: ID, Status: 0}
        this.$http.post('/configuration/deleteActivity', postData)
          .then(function (response) {
            if (response.data.error) {
              return self.$message({
                message: self.$t('ACTIVITYASSIGNEDTOSTUDENT'),
                type: 'warning',
                showClose: true
              })
            }
            self.$delete(self.activities, key)
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      deleteGrade (key, ID, Name) {
        let self = this
        if (!ID) {
          self.$delete(self.grades, key)
          return
        }
        let postData = {GradeID: ID, Status: 0, Name: Name}
        this.$http.post('/configuration/deleteGrade', postData)
          .then(function (response) {
            if (response.data.error) {
              return self.$message({
                message: self.$t('GRADEASSIGNEDTOSTUDENT'),
                type: 'warning',
                showClose: true
              })
            }
            self.$delete(self.grades, key)
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      changeMarkerPosition (lat, lng) {
        let latlng = new this.maps.LatLng(lat, lng)
        this.marker.setPosition(latlng)
        this.map.setCenter(latlng)
        this.enableConfirm = false
      }
    }
  }
</script>

<style>
.formTab .media{padding:15px}

</style>




// WEBPACK FOOTER //
// ConfigurationManage.vue?b0387a96